export const ErrorText = ({ text, children = null }) => {
    return text || children ? (
        <div
            className={
                "text-cm-p-on-container-red py-2 px-4 rounded-lg text-sm bg-cm-p-container-red flex items-center justify-center min-h-10"
            }
        >
            <div className="flex flex-col">
                {text ? <p>{text}</p> : null}
                {children}
            </div>
        </div>
    ) : null;
};
